"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.save = exports.mapHeadlineText = exports.isMeterSaved = exports.getStatus = exports.changeSerialNumberStatus = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _meterReadingFormHelper = require("../../Anonym/MeterReadingForm/meterReadingFormHelper");
var _meterReadingApi = require("../../../../api/meterReadingApi");
var _LoggedInMeterReadingStatus = require("../LoggedInMeterReadingStatus/LoggedInMeterReadingStatus");
var OrderReasons = /*#__PURE__*/function (OrderReasons) {
  OrderReasons["reason_01"] = "meterreading.headline.reason_01";
  OrderReasons["reason_03"] = "meterreading.headline.reason_03";
  OrderReasons["reason_06"] = "meterreading.headline.reason_06";
  OrderReasons["reason_09"] = "meterreading.headline.reason_09";
  OrderReasons["reason_10"] = "meterreading.headline.reason_10";
  return OrderReasons;
}(OrderReasons || {});
var mapHeadlineText = exports.mapHeadlineText = function mapHeadlineText(order, mandatoryReadingHeadlineMatrix) {
  if (order === OrderReasons.reason_01 && mandatoryReadingHeadlineMatrix) {
    return mandatoryReadingHeadlineMatrix.reason_01;
  }
  if (order === OrderReasons.reason_03 && mandatoryReadingHeadlineMatrix) {
    return mandatoryReadingHeadlineMatrix.reason_03;
  }
  if (order === OrderReasons.reason_06 && mandatoryReadingHeadlineMatrix) {
    return mandatoryReadingHeadlineMatrix.reason_06;
  }
  if (order === OrderReasons.reason_09 && mandatoryReadingHeadlineMatrix) {
    return mandatoryReadingHeadlineMatrix.reason_09;
  }
  if (order === OrderReasons.reason_10 && mandatoryReadingHeadlineMatrix) {
    return mandatoryReadingHeadlineMatrix.reason_10;
  }
  return '';
};
var isMeterSaved = exports.isMeterSaved = function isMeterSaved(savedMeters, meterReadingData) {
  return !!(savedMeters === null || savedMeters === void 0 ? void 0 : savedMeters.includes(meterReadingData.serialNumber));
};
var getStatus = exports.getStatus = function getStatus(hasError, meterReadingData, savedMeters) {
  if (hasError) {
    return _LoggedInMeterReadingStatus.PageStatus.ERROR_BG;
  }
  if (isMeterSaved(savedMeters, meterReadingData)) {
    return _LoggedInMeterReadingStatus.PageStatus.SUCCESSFUL_BG;
  }
  return '';
};
var changeSerialNumberStatus = exports.changeSerialNumberStatus = function changeSerialNumberStatus(searialNumber, status, setSerialNumberStatus) {
  setSerialNumberStatus(function (prevState) {
    var newState = (0, _toConsumableArray2.default)(prevState);
    var index = newState.findIndex(function (item) {
      return item.serialNumber === searialNumber;
    });
    if (index !== -1) {
      newState[index].status = status;
    } else {
      newState.push({
        serialNumber: searialNumber,
        status: status
      });
    }
    return newState;
  });
};
var save = exports.save = function save(values, formikHelpers, setSerialNumberStatus, markMeterSaved) {
  (0, _meterReadingApi.saveMeterReadingData)((0, _meterReadingFormHelper.prepareMeterReadingData)(values)).then(function (response) {
    if (response.data.status === 'saved') {
      markMeterSaved(values.serialNumber);
      changeSerialNumberStatus(values.serialNumber, _LoggedInMeterReadingStatus.PageStatus.SUCCESSFUL, setSerialNumberStatus);
      formikHelpers.resetForm();
      formikHelpers.setSubmitting(false);
    }
  }).catch(function (error) {
    var tempValues = (0, _toConsumableArray2.default)(values.registers);
    if (error.response.status === 422) {
      var errors = error.response.data.errors;
      errors.forEach(function (errorItem) {
        if (!(errorItem.code === 'global.validation.missingValue')) {
          var _errorItem$args, _errorItem$args2;
          changeSerialNumberStatus(values.serialNumber, _LoggedInMeterReadingStatus.PageStatus.INITIAL_BG, setSerialNumberStatus);
          var fieldValue = ((_errorItem$args = errorItem.args) === null || _errorItem$args === void 0 ? void 0 : _errorItem$args.field) ? (_errorItem$args2 = errorItem.args) === null || _errorItem$args2 === void 0 ? void 0 : _errorItem$args2.field : '';
          var index = parseInt(fieldValue.substring(fieldValue.indexOf('[') + 1, fieldValue.indexOf(']')), 10);
          if (index >= 0) {
            var _errorItem$args3;
            tempValues[index].possibleReadingNotes = (_errorItem$args3 = errorItem.args) === null || _errorItem$args3 === void 0 ? void 0 : _errorItem$args3.readingNotes;
            tempValues[index].errorCode = errorItem.code;
          }
        }
      });
    }
    formikHelpers.setFieldValue('registers', tempValues, false);
    formikHelpers.setSubmitting(false);
  });
};